import { getEventPhases, isEventInPreregistration } from '@/store/availableActions/utils/event';

export function getIsEventInPreregistrationPhase(event) {
  const eventPhases = getEventPhases(event);

  return isEventInPreregistration(eventPhases);
}
